export enum WorkflowTypes {
  StartFlow = 1,
  OrderStatus = 2,
  Shopping = 3,
}

export enum WorkflowElements {
  Begin = 1,
  Message = 2,
  Menu = 3,
  Process = 4,
  Question = 5,
  Input = 6,
  End = 7,
}

export enum WorkflowStatus {
  Active = "active",
  Inactive = "inactive",
  Archived = "archived",
}

export enum WorkflowAction {
  Start = "start",
  Pause = "pause",
  Resume = "resume",
  Complete = "complete",
}
